import { Icon, IconTypes, Tooltip } from '@vallourec-ui/vallourec-ui'
import React, { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import { MessageWrapper, Label, StyledTextInput } from './style'
import { CustomTextInputProps } from '@/@types/global'
import { FlexView } from '@/components/common'

interface InputProps extends CustomTextInputProps {
  label?: string
  inline?: boolean
  width?: string
  margin?: string
  message?: string
  messageType?: 'error' | 'success' | 'warning' | 'info'
  maxChar?: number
  icon?: IconTypes
  iconColor?: string
  tooltip?: string
  name: string
  indexFocus?: number
  fromHowFrom?: boolean
}

const TextFieldInput = forwardRef<HTMLInputElement, InputProps>(
  function TextFieldInput(props, ref) {
    const {
      label,
      inline,
      width,
      margin,
      message,
      messageType,
      maxChar,
      name,
      icon,
      iconColor,
      tooltip,
      indexFocus,
      fromHowFrom,
      ...additionalProps
    } = props

    const { t } = useTranslation()
    let iconName: IconTypes = ''
    switch (messageType) {
      case 'error':
        iconName = 'cross'
        break
      case 'success':
        iconName = 'check'
        break
      case 'warning':
        iconName = 'warning'
        break
      case 'info':
        iconName = 'info'
        break
    }

    return (
      <FlexView width={width} margin={margin}>
        <FlexView
          backgroundColor="inherit"
          width="100%"
          flexDirection={inline ? 'row' : 'column'}
          alignItems="stretch"
          justifyContent="flex-start"
          fontSize="text-md"
          fontWeight="regular"
        >
          {label && (
            <Label>
              {' '}
              {additionalProps.required
                ? `${t<string>(label)}*`
                : t<string>(label)}
            </Label>
          )}
          <StyledTextInput
            {...additionalProps}
            ref={ref}
            id={`index-focus-${indexFocus}`}
            onKeyPress={(e) => {
              if (!fromHowFrom) {
                return e
              }

              e.key === 'Enter' && e.preventDefault()

              /* const index = indexFocus || 0
              const jump =
                index +
                (index % 6 === 0
                  ? 1
                  : [4, 5, 10, 11, 16, 17, 22, 23].includes(index)
                    ? -2
                    : 3)

              document
                .getElementById(
                  // `index-focus-${(indexFocus || 0) + 1)}`
                  `index-focus-${jump}`
                )
                ?.focus() */
            }}
          >
            {tooltip && (
              <Tooltip label={tooltip}>
                <Icon name="QuestionLine" color="neutral-color-40" />
              </Tooltip>
            )}
          </StyledTextInput>
        </FlexView>
        {message && (
          <MessageWrapper>
            <Icon name="CloseCircleLine" color={messageType} />
          </MessageWrapper>
        )}
        {maxChar && (
          <MessageWrapper>
            {t<string>('newAnalysis.characterLimit', { maxChar })}
          </MessageWrapper>
        )}
      </FlexView>
    )
  }
)

export default TextFieldInput
